(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Network', Network);

    Network.$inject = ['$resource'];

    function Network($resource) {
        var service = $resource('api/connexions/network', {}, {
            'getList': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/network?size=100'
            },
            'getListConnuParConsultant': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/network/connuParConsultant?size=200&organizationId=:organizationId'
            },
            'networkSearch': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/network/search/:query'
            },
            'getByOrganizationId': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions?organizationId=:organizationId'
            },
            'getInternalNetwork': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/internalnetwork'
            },
            'getInternalNetworkOrganisation': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/internalnetworkorganisation?size=200&organizationId=:organizationId'
            },


        });
        return service;
    }
})();
